<template>
  <section class="section container">
    <div>
      <h1 class="title">Configuración del módulo</h1>

      <div class="field">
        <label class="label">Campo de texto 1</label>
        <div class="control">
          <input class="input" type="text" v-model="setting_1" />
        </div>
      </div>

      <div class="field">
        <label class="label">Campo de texto 2</label>
        <div class="control">
          <input class="input" type="text" v-model="setting_2" />
        </div>
      </div>

      <div class="field">
        <label class="label">Dropdown</label>
        <div class="control">
          <div class="select">
            <select v-model="setting_3">
              <option value="option1">Option 1</option>
              <option value="option2">Option 2</option>
              <option value="option3">Option 3</option>
            </select>
          </div>
        </div>
      </div>

      <div class="field">
        <div class="control">
          <button class="button is-primary" @click="save">Guardar</button>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { save_configuration, get_configuration } from "@/utils";

export default {
  data() {
    return {
      setting_1: "",
      setting_2: "",
      setting_3: "",
    };
  },
  methods: {
    save() {
      let data = this.$data;
      v.$root.loader(true);
      save_configuration(this, data)
        .then((response) => {
          console.log("configuration saved", response);
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => v.$root.loader(false));
    },
  },
  created() {
    let v = this;
    v.$root.loader(true);
    get_configuration(this)
      .then((conf) => {
        v.setting_1 = conf.setting_1;
        v.setting_2 = conf.setting_2;
        v.setting_3 = conf.setting_3;
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => v.$root.loader(false));
  },
};
</script>

<style></style>
